import { BaseDto } from './base.dto';

export class StockOrderStatusDto extends BaseDto {
  name: string;
  sequence: number;
}
